import * as React from 'react';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import SellerTableRow from './SellerTableRow';
import Table from '@liveauctioneers/caterwaul-components/lib/Table/Table';

type Props = {
    className?: string;
    sellerIds: number[];
};

const SellerTable = ({ className = '', sellerIds = [] }: Props) => (
    <Table className={cn('mt-xs w-full', className)}>
        <thead>
            <tr>
                <th>
                    <FormattedMessage id="auctioneer" />
                </th>
                <th className="xsMax:hidden">
                    <FormattedMessage id="upcoming_auct" />
                </th>
                <th className="text-right">
                    <FormattedMessage id="unfollow" />
                </th>
            </tr>
        </thead>
        <tbody>
            {sellerIds.map(
                React.useCallback(
                    (sellerId) => (
                        <SellerTableRow
                            key={sellerId}
                            sellerId={sellerId}
                        />
                    ),
                    []
                )
            )}
        </tbody>
    </Table>
);

export default SellerTable;
